__webpack_require__.p = "/mq-dev-patterns/";